import { Text, View } from "react-native";
import PopOver from "./PopOver";
import Button from "./Button";

export const EmploymentWarningModal = ({
  visible,
  onDismiss,
  title,
  text,
  onContinue,
  TextComponent,
}: {
  visible: boolean;
  onDismiss(): void;
  title: string;
  text: string;
  onContinue(): void;
  TextComponent?: React.FC;
}) => {
  return (
    <PopOver visible={visible} onDismiss={onDismiss} size="md">
      <Text className="text-ink-darkest font-700 text-title-5 mb-2">{title}</Text>

      <Text className="text-regular-normal font-400 text-ink-dark mb-6 mt-2">{text}</Text>

      {TextComponent && <TextComponent />}

      <View className="flex-col justify-between mt-2">
        <Button mode="contained" size="large" onPress={onContinue}>
          Continue
        </Button>

        <Button size="large" onPress={onDismiss} className="mt-3">
          Cancel
        </Button>
      </View>
    </PopOver>
  );
};
